import axiosApiClient from "../axios";

const PATH = '/api/user';

export const getAllUsers = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all users');
    }
};

export const getAllUserByUserName = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/${username}/username`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get user by username');
    }
};

export const getUserById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get user by ID');
    }
};

export const addUser = async (user) => {
    try {
        return await axiosApiClient.post(PATH, user, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Add User failed');
    }
};

export const deleteUser = async (userId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${userId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete User failed');
    }
};

export const updateUser = async (userId, user) => {
    try {
        return await axiosApiClient.put(`${PATH}/${userId}`, user, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update User failed');
    }
};

export const updateCurrentUser = async (user) => {
    try {
        return await axiosApiClient.put(`${PATH}/profile`, user, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Profile failed');
    }
};

